import { useEffect, useState } from "react";
import { Empty, Button } from "antd";
import { useOutletContext } from "react-router-dom";

import TAAddModal from "../../taAddModal";
import CustomerTableSelectable from "../../customerTableSelectable";

import useMembersStore from "../../../store/members.store";
import useClientStore from "../../../store/clientModal.store";

const taListTitle = [
  "Select",
  "S. No.",
  "TA Name",
  "Contact Number",
  "Email ID",
  "Role",
  "Group",
  "Lead",
  "Manager",
  "Project",
  "Added On",
];

function TAList() {
 
  const { clientID, clientName } = useOutletContext();

  const { clients, getClients } = useMembersStore();
  const { setModalOpen, removeClientTA } = useClientStore();

  const [taList, setTAList] = useState([]);

  useEffect(() => {
    getClients();
  }, [getClients]);

  useEffect(() => {
    if (!clients?.[clientID]) return;

    const client = clients[clientID];

    if (client.ClientName !== clientName) return;

    const mappedList =
      client.ClientTAList?.map((ta, idx) => ({
        select: "",
        id: idx + 1,
        name: ta?.TAName,
        contact: ta?.TANumber,
        email: ta?.TAMail,
        role: ta?.TARole,
        group: ta?.TAGroup,
        lead: ta?.TALead,
        manager: ta?.TAManager,
        project: ta?.TAProject,
        addedDate: ta?.TAAdditionDate,
      })) || [];

    setTAList(mappedList);
  }, [clients, clientID, clientName]);

  return (
    <div className="customers-container">
      <div className="customer-members-wrapper">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 className="customer-members-list-title">{clients?.[clientID]?.ClientName.toUpperCase()} TAs</h2>

          <Button type="primary" onClick={() => setModalOpen()}>
            + Add new TAs
          </Button>
        </div>

        {taList.length > 0 ? (
          <CustomerTableSelectable
            titleList={taListTitle}
            data={taList}
            removeClientTA={removeClientTA}
            clientName={clientName}
          />
        ) : (
          <Empty style={{ margin: 60 }} />
        )}
      </div>

      <TAAddModal clientName={clientName} />
    </div>
  );
}

export default TAList;